import * as actionTypes from './constants'

export function login(email, password) {
  return {
    type: actionTypes.LOGIN,
    email,
    password
  }
}

export function logout() {
  return {
    type: actionTypes.LOGOUT
  }
}

export function setUser(user) {
  return {
    type: actionTypes.SET_USER,
    user
  }
}

export function showMyProjects() {
  return {
    type: actionTypes.SHOW_MY_PROJECTS
  }
}
